import moment from "moment";
import { gr } from "src/design-system/tokens";
import icons from "src/design-system/icons";

// Shared by the Videos Library list / detail / cards.

// Vimeo "share" links (vimeo.com/share/…) open in a browser but cannot be embedded as they are.
export const isVimeoShareLink = (url) =>
  /^https:\/\/(www\.)?vimeo\.com\/share\//i.test(String(url || "").trim());

export const libraryGridSx = {
  display: "grid",
  gridTemplateColumns: {
    xs: "1fr",
    sm: "repeat(2, minmax(0, 1fr))",
    lg: "repeat(3, minmax(0, 1fr))",
  },
  gap: gr.space[6],
};

// Cards in the first row of a card grid (at most 3 across) are on screen at once: their images load
// eagerly (GrMediaCard `eagerImage`), the rest lazily as the member scrolls.
export const isFirstRow = (index) => index < 3;

// Buttons inside a clickable card do their own thing, not the card's.
export const ownAction = (run) => ({
  onClick: (e) => {
    e.stopPropagation();
    run();
  },
  onKeyDown: (e) => e.stopPropagation(),
});

// The task a video belongs to: practice type first, library type as fallback.
const TYPES = [
  { practice: "workout", library: "workout-type", label: "Workout", icon: icons.taskWorkout },
  { practice: "food", library: "meal-type", label: "Nutrition", icon: icons.taskMeal },
  { practice: "mindset", library: "mindset-type", label: "Mindset", icon: icons.taskMindset },
  { practice: "video", label: "Video", icon: icons.taskVideo },
  { practice: "workbook", label: "Workbook", icon: icons.taskWorkbook },
  { practice: "comment", label: "Comment", icon: icons.taskComment },
];
export const videoType = (video) =>
  TYPES.find((t) => t.practice === video?.practice_type) ||
  TYPES.find((t) => t.library && t.library === video?.library_type) || {
    label: "Video",
    icon: icons.taskVideo,
  };

// Default date range of the library: the last month up to today.
export const lastMonthRange = () => {
  const start = new Date();
  start.setMonth(start.getMonth() - 1);
  return { start, end: new Date() };
};

export const isSameRange = (a, b) =>
  moment(a?.start).isSame(b?.start, "day") && moment(a?.end).isSame(b?.end, "day");
